// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"6bce633d","710":"19a3c5ae","975":"cf1680ee","983":"0bceaf52"}[chunkId] + ".chunk.js";
};